import React from 'react';
import { injectIntl } from "react-intl";
import { withStyles } from '@material-ui/core/styles';
import { Avatar, Divider, ListItem, Typography } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import moment from 'moment-timezone';
import styles from './styles';
import useGlobalContext from '../../../common/hooks/useGlobalContext';
import messages from "./messages";

const RideInfoCard = props => {
  const {
    classes,
    intl: { formatMessage },
    rideInfo,
  } = props;
  const {
    state: { activeService },
    setRideInfo,
    setOpenRightDetailsPanel,
  } = useGlobalContext();
  const { time_zone } = activeService;
  const {
    id,
    driver,
    dropoff_eta,
    end_location,
    expected_duration,
    is_complete,
    is_completed,
    num_passengers,
    payment,
    phone_number,
    phone_number_display,
    pickup_eta,
    rider_name,
    rider_name_display,
    scheduled_for_pickup_at,
    start_location,
    state_display,
    vehicle,
  } = rideInfo;
  let riderPassengerDisplay = num_passengers;

  const generateStatusDisplay = () => {
    let rideInfoDisplay;
    let time;
    if (is_completed) {
      time = moment(is_complete)
        .tz(time_zone)
        .format('h:mm a, M/D/YY');
      rideInfoDisplay = `${state_display}: ${time}`;
    } else if (scheduled_for_pickup_at) {
      time = moment(scheduled_for_pickup_at)
        .tz(time_zone)
        .format('h:mm a, M/D/YY');
      rideInfoDisplay = `${formatMessage(messages.upcomingRide)}: ${time}`;
    } else if (rideInfo.state === 'matched') {
      time = moment(pickup_eta)
        .tz(time_zone)
        .format('h:mm a');
      rideInfoDisplay = `${formatMessage(messages.awaitingPickup)} - ${formatMessage(messages.driverETA)} ${time}`;
    } else if (rideInfo.state === 'picked_up') {
      time = moment(dropoff_eta)
        .tz(time_zone)
        .format('h:mm a');
      rideInfoDisplay = `${state_display} - ${formatMessage(messages.ETA)} ${time}`;
    } else {
      rideInfoDisplay = state_display;
    }
    return rideInfoDisplay;
  };

  if (riderPassengerDisplay === 1) riderPassengerDisplay = `${riderPassengerDisplay} ${formatMessage(messages.rider)}`;
  else riderPassengerDisplay = `${riderPassengerDisplay} ${formatMessage(messages.riders)}`;

  const riderName = rider_name || rider_name_display;
  const riderNumber = phone_number_display || phone_number;
  const driverName = driver ? driver.full_name : formatMessage(messages.noDriverAssigned);

  const generateVehicleDescription = () => {
    let vehicleDescription;
    if (vehicle) vehicleDescription = vehicle.dispatch_description;
    else if (driver && driver.vehicle) vehicleDescription = driver.vehicle.dispatch_description;
    return vehicleDescription;
  };

  const generateFareAmount = () => {
    let fareAmount='';
    if (is_completed && payment) {
      const { total_to_charge_display } = payment;
      fareAmount = ' || ' + total_to_charge_display;
    }
    return fareAmount;
  };

  const rideStatus = generateStatusDisplay();

  const rideDetails = {
    scheduledRide: !!scheduled_for_pickup_at,
    expectedDuration: expected_duration,
    id,
    driverName,
    endAddress: end_location.dispatcher_display_address,
    is_completed,
    licensePlate: vehicle && vehicle.license_plate_number,
    numRiders: riderPassengerDisplay,
    payment,
    riderName,
    riderNumber,
    startAddress: start_location.dispatcher_display_address,
    status: rideStatus,
    vehicleDescription: generateVehicleDescription(),
  };

  const packageRide = expected_duration ? `[${formatMessage(messages.package)}]` : null

  return (
    <React.Fragment>
      <ListItem
        button
        className={classes.listItem}
        onClick={() => {
          setOpenRightDetailsPanel(true);
          setRideInfo(rideDetails);
        }}
      >
        <Avatar alt={riderName} className={classes.avatar} />
        <div>
          <Typography>{riderName}</Typography>
          <Typography
            className={classes.listItemSubtext}
            variant="body2"
          >{`${riderPassengerDisplay} ${generateFareAmount()}`} {packageRide}</Typography>
          <Typography className={classes.listItemSubtext} variant="body2">
            {rideStatus}
          </Typography>
        </div>
        <ChevronRight className={classes.iconRight} />
      </ListItem>
      <Divider variant="inset" component="li" />
    </React.Fragment>
  );
};

export default withStyles(styles)(injectIntl(RideInfoCard));
